export const animateCards = (
  tl: gsap.core.Timeline,
  cardsWrapper: HTMLElement,
) => {
  tl.to(cardsWrapper, {y: 20, duration: 0.3, ease: 'power1.out'}, 0).to(
    cardsWrapper,
    {
      y: 0,
      duration: 0.3,
      ease: 'power1.out',
    },
    0.3,
  );
};
